import Vue from 'vue';
import type { Route } from 'vue-router';

export default (): Route => {
	return Vue.prototype.$nuxt._route;
};
